
import {Vue, Component, Prop} from 'vue-property-decorator';
@Component
export default class RootElement extends Vue {
  @Prop({default: 'div'})
  private tag!: string;

  private render(createElement: any) {
    return createElement(this.tag, this.$slots.default);
  }
}
